import Footer from "../components/Footer";
import PaymentBadges from "../components/PaymentBadges";
import ProcessSection from "../components/ProcessSection";
import ImageGuidelinesSection from "../components/ImageGuidelinesSection";

// WhatsApp business number - update this with your actual number
const WHATSAPP_NUMBER = "94771234567"; // Format: country code + number without + or spaces
const WHATSAPP_DESIGN_MESSAGE = "Hi! I'd like to talk to you about designing my custom 3D Night Lamp.";

const NightLamp = () => {
  const imageCardClass =
    "rounded-md sm:rounded-lg overflow-hidden shadow-md sm:shadow-lg w-full max-w-[150px] sm:max-w-[190px] md:max-w-[220px] mx-auto";
  const imageAspectStyle = { aspectRatio: '3/5' };

  return (
    <main className="bg-white text-gray-900">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-[#E85D44] to-[#ff5c4d] pt-32 pb-20 px-6 overflow-hidden">
        <div className="max-w-screen-xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Left Content */}
            <div className="space-y-8 text-white">
              <div className="space-y-4">
                <p className="text-sm uppercase tracking-[0.3em] text-white/80">
                  ILLUMINATE YOUR MEMORIES
                </p>
                <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold leading-tight">
                  3D Lithophane Night Lamp
                </h1>
                <p className="text-xl text-white/90 leading-relaxed">
                  Turn your photos into glowing 3D art
                </p>
              </div>

              {/* Key Features */}
              <div className="flex flex-wrap gap-4 text-sm">
                <span className="bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full">3D Printed</span>
                <span className="bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full">Warm LED</span>
                <span className="bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full">Batteries Included</span>
              </div>

              {/* Price & CTA */}
              <div className="space-y-4">
                <div className="inline-flex items-baseline gap-2">
                  <span className="text-5xl font-bold">Rs. 4,890</span>
                  <span className="text-white/80">+ Free Delivery</span>
                </div>
                <div className="space-y-4">
                  <a
                    href="/design"
                    className="inline-block px-10 py-4 bg-white text-[#E85D44] hover:bg-gray-100 font-semibold text-sm uppercase tracking-[0.2em] rounded-lg transition-all duration-300 shadow-xl hover:shadow-2xl"
                  >
                    Start Designing Now
                  </a>

                  {/* WhatsApp Design Assistance */}
                  <div className="flex flex-col items-start gap-2">
                    <a
                      href={`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_DESIGN_MESSAGE)}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-3 px-6 py-3 bg-[#25D366] hover:bg-[#128C7E] text-white font-semibold text-sm uppercase tracking-[0.15em] rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl"
                    >
                      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                      </svg>
                      Talk to Us for Your Design
                    </a>
                    <p className="text-xs text-white/70">
                      *Terms & Conditions Apply
                    </p>
                  </div>

                  {/* Payment Badges */}
                  <PaymentBadges />
                </div>
              </div>
            </div>

            {/* Right Images */}
            <div className="relative">
              <div className="grid grid-cols-2 gap-4">
                <div className="relative rounded-2xl overflow-hidden shadow-2xl transform hover:scale-105 transition-transform">
                  <img src="/images/hero-02-off.png" alt="Lamp off" className="w-full h-full object-cover" loading="eager" />
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-3">
                    <p className="text-white text-xs font-semibold text-center">OFF</p>
                  </div>
                </div>
                <div className="relative rounded-2xl overflow-hidden shadow-2xl transform hover:scale-105 transition-transform">
                  <img src="/images/hero-02-on.png" alt="Lamp on" className="w-full h-full object-cover" loading="eager" />
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-3">
                    <p className="text-white text-xs font-semibold text-center">ON</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Quick Spec Strip */}
      <section className="bg-[#FFF5F2] py-16 px-6">
        <div className="max-w-screen-xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-[#E85D44]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-[#E85D44]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
                </svg>
              </div>
              <h3 className="font-bold text-gray-900 mb-2">Material</h3>
              <p className="text-sm text-gray-600">PLA+ bio-based polymer, satin white finish</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-[#E85D44]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-[#E85D44]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="font-bold text-gray-900 mb-2">Print Time</h3>
              <p className="text-sm text-gray-600">~9 hours for full lamp production</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-[#E85D44]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-[#E85D44]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                </svg>
              </div>
              <h3 className="font-bold text-gray-900 mb-2">Lighting</h3>
              <p className="text-sm text-gray-600">Warm LED, 2×AA batteries included</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-[#E85D44]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-[#E85D44]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                </svg>
              </div>
              <h3 className="font-bold text-gray-900 mb-2">Warranty</h3>
              <p className="text-sm text-gray-600">6 months electronics</p>
            </div>
          </div>
        </div>
      </section>

      {/* What is a Lithophane */}
      <section className="py-20 px-6 bg-white">
        <div className="max-w-screen-xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="space-y-6">
              <p className="text-sm uppercase tracking-[0.3em] text-[#E85D44]">
                THE SCIENCE OF LIGHT
              </p>
              <h2 className="text-4xl md:text-5xl font-serif text-gray-900 leading-tight">
                Sculpted Light: The Art of Lithophanes
              </h2>
              <p className="text-gray-600 leading-relaxed">
                A lithophane encodes your photo into depth. Under light, the depth
                differences turn into a high-contrast image; without light, you see a
                tactile relief. We 3D-print this relief in precise layers, then fit a warm
                LED so your memory glows at night and looks elegant by day.
              </p>
              <p className="text-gray-600 leading-relaxed">
                We use white filament for the most accurate light transmission and contrast,
                creating a truly magical effect that brings your memories to life.
              </p>
              <div className="pt-4">
                <a
                  href="/how-it-works"
                  className="inline-block bg-transparent border-2 border-gray-300 hover:border-[#E85D44] hover:bg-[#E85D44] text-gray-700 hover:text-white font-semibold text-sm uppercase tracking-[0.2em] px-8 py-3 transition-all duration-300"
                >
                  Learn More
                </a>
              </div>
            </div>
            <div className="grid grid-cols-1 gap-4">
              <div className="rounded-lg overflow-hidden">
                <img src="/images/on-off-compare.jpg" alt="On vs off" className="w-full h-full object-cover" loading="lazy" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Feel the Photo */}
      <section className="py-20 px-6 bg-[#FFF5F2]">
        <div className="max-w-screen-xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="rounded-lg overflow-hidden">
              <img src="/images/touch-relief.jpg" alt="Touching relief" className="w-full h-full object-cover" loading="lazy" />
            </div>
            <div className="space-y-6">
              <p className="text-sm uppercase tracking-[0.3em] text-[#E85D44]">
                TACTILE EXPERIENCE
              </p>
              <h2 className="text-4xl md:text-5xl font-serif text-gray-900 leading-tight">
                Looks Engraved. Feels Engraved.
              </h2>
              <p className="text-gray-600 leading-relaxed text-lg">
                Unlike flat prints, the lamp's surface has real depth. Run your fingers
                across the image—highlights and shadows are literal ridges and valleys.
                That's why people say it feels engraved, not just printed.
              </p>
              <p className="text-gray-600 leading-relaxed">
                Perfect for intimate, meaningful gifts that engage both sight and touch.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Why Warm Light */}
      <section className="py-20 px-6 bg-white">
        <div className="max-w-screen-xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="space-y-6">
              <p className="text-sm uppercase tracking-[0.3em] text-[#E85D44]">
                DESIGNED FOR COMFORT
              </p>
              <h2 className="text-4xl md:text-5xl font-serif text-gray-900 leading-tight">
                Naturally Calming Glow
              </h2>
              <p className="text-gray-600 leading-relaxed">
                We choose warm LEDs because people generally rate warm light as more
                pleasant and relaxing than cool at the same brightness. Evening exposure to
                blue-depleted light also tends to suppress melatonin less than standard
                cool sources—good news for winding down.
              </p>
              <div className="bg-[#FFF5F2] border-l-4 border-[#E85D44] p-4 rounded">
                <p className="text-sm text-gray-600">
                  <strong>Note:</strong> This is about ambience, not medical treatment. Our warm LEDs create
                  a cozy atmosphere perfect for bedtime routines.
                </p>
              </div>
            </div>
            <div className="rounded-lg overflow-hidden shadow-xl">
              <img src="/images/warm-ambient.png" alt="Warm ambient" className="w-full h-full object-cover" loading="lazy" />
            </div>
          </div>
        </div>
      </section>

      {/* How Yours Is Made */}
      <ProcessSection />

      {/* Sizes, Specs & Care */}
      <section className="py-20 px-6 bg-white">
        <div className="max-w-screen-xl mx-auto">
          <div className="text-center mb-12">
            <p className="text-sm uppercase tracking-[0.3em] text-[#E85D44] mb-4">
              PRODUCT DETAILS
            </p>
            <h2 className="text-4xl md:text-5xl font-serif text-gray-900 mb-6">
              Sizes, Specs & Care
            </h2>
          </div>

          {/* Specification Tiles */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
            {/* Dimensions Tile */}
            <div className="bg-[#FFF5F2] rounded-2xl p-6 shadow-lg hover:shadow-xl transition-shadow">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-[#E85D44] rounded-full flex items-center justify-center flex-shrink-0">
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4" />
                  </svg>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">Dimensions</h3>
                  <p className="text-sm text-gray-600">~15 cm tall × 8 cm diameter</p>
                </div>
              </div>
            </div>

            {/* Power Tile */}
            <div className="bg-[#FFF5F2] rounded-2xl p-6 shadow-lg hover:shadow-xl transition-shadow">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-[#E85D44] rounded-full flex items-center justify-center flex-shrink-0">
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                  </svg>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">Power</h3>
                  <p className="text-sm text-gray-600">Warm LED, 2×AA batteries included</p>
                </div>
              </div>
            </div>

            {/* Material Tile */}
            <div className="bg-[#FFF5F2] rounded-2xl p-6 shadow-lg hover:shadow-xl transition-shadow">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-[#E85D44] rounded-full flex items-center justify-center flex-shrink-0">
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
                  </svg>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">Material</h3>
                  <p className="text-sm text-gray-600">PLA+ bio-based, low odor</p>
                </div>
              </div>
            </div>

            {/* Finish Tile */}
            <div className="bg-[#FFF5F2] rounded-2xl p-6 shadow-lg hover:shadow-xl transition-shadow">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-[#E85D44] rounded-full flex items-center justify-center flex-shrink-0">
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01" />
                  </svg>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">Finish</h3>
                  <p className="text-sm text-gray-600">Satin white lithophane with matte base</p>
                </div>
              </div>
            </div>

            {/* Care Tile */}
            <div className="bg-[#FFF5F2] rounded-2xl p-6 shadow-lg hover:shadow-xl transition-shadow">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-[#E85D44] rounded-full flex items-center justify-center flex-shrink-0">
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4" />
                  </svg>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">Care</h3>
                  <p className="text-sm text-gray-600">Dust gently, avoid heat &gt;55°C, indoor use only</p>
                </div>
              </div>
            </div>

            {/* Usage Tile */}
            <div className="bg-[#FFF5F2] rounded-2xl p-6 shadow-lg hover:shadow-xl transition-shadow">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-[#E85D44] rounded-full flex items-center justify-center flex-shrink-0">
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                  </svg>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">Display</h3>
                  <p className="text-sm text-gray-600">OFF: white relief, ON: golden glow</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Make It Yours- Image Requirements */}
      <ImageGuidelinesSection />

      {/* Final CTA */}
      <section className="py-20 px-6 bg-gradient-to-br from-[#E85D44] to-[#D44D34] text-white text-center">
        <div className="max-w-4xl mx-auto">
          <p className="text-sm uppercase tracking-[0.3em] text-white/80 mb-4">
            CREATE YOUR MEMORY
          </p>
          <h2 className="text-4xl md:text-5xl font-serif mb-6">
            Ready to Make Yours?
          </h2>
          <p className="text-lg mb-8 text-white/90">
            Start with a template, upload photos, preview in 3D, and place your order.
          </p>

          {/* Price Card */}
          <div className="bg-white text-gray-900 rounded-lg p-8 inline-block shadow-2xl mb-8">
            <p className="text-sm text-gray-500 mb-2 uppercase tracking-wider">Complete Lithophane Lamp</p>
            <p className="text-5xl font-bold text-[#E85D44] mb-1">Rs. 4,890</p>
            <p className="text-sm text-gray-500">+ Delivery Free</p>
          </div>

          {/* Action Button */}
          <div className="flex justify-center">
            <a
              href="/design"
              className="px-10 py-4 bg-white text-[#E85D44] hover:bg-gray-100 font-semibold text-sm uppercase tracking-[0.2em] rounded transition-all duration-300 shadow-lg hover:shadow-xl"
            >
              Start Design Yours Now
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
};

export default NightLamp;
